import React, { useEffect, useState, Fragment } from "react";
import { message, Popconfirm, Table, Button, Modal, DatePicker, Space, Radio } from "antd";
import DataNotFound from "../atoms/DataNotFound";
import styled from "styled-components";
import Loader from "../atoms/Loader";
const axios = require("axios").default;

const TrainerPlans = (props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [selectedDate, setSelectedDate] = useState(null);
  // Listeye uygulanmış tarih filtresi (YYYY-MM-DD); null ise tüm planlar
  const [appliedDate, setAppliedDate] = useState(null);
  // Öğrencisi olan randevu silinirken iptal sebebi seçilir ve öğrenciye mail gider
  const [cancelRecord, setCancelRecord] = useState(null);
  const [cancelReason, setCancelReason] = useState(null);
  const [canceling, setCanceling] = useState(false);

  const handleOk = () => {
    setIsModalVisible(false);
    props.visiblePlanCallback(null);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    props.visiblePlanCallback(null);
  };

  // silent: tabloyu unmount etmeden yenile (sayfa bilgisi korunur)
  const getPlans = (silent = false, date = appliedDate) => {
    silent ? setRefreshing(true) : setLoading(true);
    axios.get(`trainer/plans/${props.plan.id}`, { params: date ? { date } : {} })
      .then(function (response) {
        const list = response.data.list;
        setPlans(list);
        // Son sayfadaki son kayıt silindiyse bir önceki sayfaya geç
        setPagination((prev) => {
          const maxPage = Math.max(1, Math.ceil(list.length / prev.pageSize));
          return prev.current > maxPage ? { ...prev, current: maxPage } : prev;
        });
      })
      .catch(function (error) {
        console.log(error)
      }).finally(() => {
        silent ? setRefreshing(false) : setLoading(false);
    })
  };

  const PlanDelete = (id, reason) => {
    return axios
      .get(`trainer/plan-delete/${id}`, { params: reason ? { reason } : {} })
      .then(function (response) {
        const { message: warning, mailSent, whatsappSent } = response.data;
        if (warning) {
          message.warning(warning);
        } else {
          const sent = [mailSent && "mail", whatsappSent && "WhatsApp"].filter(Boolean);
          message.info(sent.length ? `Deleted, ${sent.join(" and ")} sent to student` : "Deleted");
        }
        getPlans(true);
      })
      .catch(function (error) {
          console.log(error)
          const data = error.response && error.response.data;
          message.error((data && (data.detail || data.message)) || "Plan silinemedi");
      });
  };

  const openCancelModal = (record) => {
    setCancelRecord(record);
    setCancelReason(null);
  };

  const handleCancelAppointment = () => {
    setCanceling(true);
    PlanDelete(cancelRecord.id, cancelReason).finally(() => {
      setCanceling(false);
      setCancelRecord(null);
    });
  };

  const applyDateFilter = (date) => {
    setAppliedDate(date);
    setPagination((prev) => ({ ...prev, current: 1 }));
    getPlans(false, date);
  };

  const handleFilter = () => {
    applyDateFilter(selectedDate ? selectedDate.format("YYYY-MM-DD") : null);
  };

  const handleClearFilter = () => {
    setSelectedDate(null);
    applyDateFilter(null);
  };

  useEffect(() => {
    if (props.plan.length !== 0) {
      getPlans();
      setIsModalVisible(true);
    }
  }, []);

  const columns = [
    {
      title: "Plan No",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Name",
      dataIndex: "last_name",
      key: "first_name",
      render: (text, record) => {
        return <>{record.first_name + " " + record.last_name}</>;
      },
    },
    {
      title: "Date",
      dataIndex: "schedule_date",
      key: "schedule_date",
    },
    {
      title: "Start",
      dataIndex: "start_time",
      key: "start_time",
    },
    {
      title: "End",
      dataIndex: "end_time",
      key: "end_time",
    },
    {
      title: "Appointment",
      dataIndex: "stulast",
      key: "stulast",
      render: (text, record) => {
        return (
          <>
            <div>
              {record.stuname} {record.stulast}
            </div>
            {record.email && (
              <div style={{ fontSize: 12, color: "#8c8c8c" }}>{record.email}</div>
            )}
          </>
        );
      },
    },
    {
      title: "",
      dataIndex: "",
      key: "",
      align: "center",
      render: (text, record) => {
        return (
          <>
            {record.student_id ? (
              <Button type="primary" danger onClick={() => openCancelModal(record)}>
                Delete
              </Button>
            ) : (
              <Popconfirm
                placement="topLeft"
                title={"Are you sure ?"}
                onConfirm={() => PlanDelete(record.id)}
                okText="Yes"
                cancelText="No"
              >
                <Button type="primary" danger>
                  Delete
                </Button>
              </Popconfirm>
            )}
          </>
        );
      },
    },
  ];

  return (
    <>
      <ModalX
        title="Plans"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={1000}
        bodyStyle={{overflowY: 'auto', maxHeight: 'calc(100vh - 200px)'}}
      >
        <Space style={{ marginBottom: 16 }}>
          <DatePicker
            value={selectedDate}
            onChange={(value) => setSelectedDate(value)}
            format="DD-MM-YYYY"
            placeholder="Select date"
          />
          <Button type="primary" onClick={handleFilter} disabled={loading}>
            Filter
          </Button>
          <Button onClick={handleClearFilter} disabled={loading || (!selectedDate && !appliedDate)}>
            Clear
          </Button>
        </Space>
        {loading ? (
                <StyledLoad>
                  <Loader size={"sm"} />
                </StyledLoad>
            ):

        plans.length > 0 ? (
          <Table
            rowKey="id"
            loading={refreshing}
            pagination={{
              ...pagination,
              onChange: (current, pageSize) => setPagination({ current, pageSize }),
            }}
            columns={columns}
            dataSource={plans}
          />
        )
        :
            <DataNotFound
                top={"50%"}
                left={"50%"}
                position={"fixed"}
            />
        }
      </ModalX>

      <Modal
        title="Randevu iptal sebebi"
        visible={!!cancelRecord}
        onCancel={() => setCancelRecord(null)}
        onOk={handleCancelAppointment}
        okText="Delete"
        okButtonProps={{ danger: true, disabled: !cancelReason }}
        confirmLoading={canceling}
      >
        {cancelRecord && (
          <>
            <p style={{ marginBottom: 12, color: "#555" }}>
              {`${cancelRecord.stuname} ${cancelRecord.stulast} · ${cancelRecord.schedule_date} ${cancelRecord.start_time} - ${cancelRecord.end_time}`}
            </p>
            <Radio.Group value={cancelReason} onChange={(e) => setCancelReason(e.target.value)}>
              <Space direction="vertical">
                <Radio value="technical">Teknik sorun</Radio>
                <Radio value="health">Sağlık nedeni</Radio>
              </Space>
            </Radio.Group>
            <p style={{ marginTop: 12, fontSize: 12, color: "#8c8c8c" }}>
              {cancelRecord.email
                ? `Seçilen sebebe göre ${cancelRecord.email} adresine iptal maili gönderilecek.`
                : "Öğrencinin e-posta adresi olmadığı için mail gönderilmeyecek."}
              {" Öğrencinin telefonu kayıtlıysa WhatsApp mesajı da gönderilecek."}
            </p>
          </>
        )}
      </Modal>
    </>
  );
};

const ModalX = styled(Modal)`
  .ant-modal-content{
    min-height:530px;
  }
`
const StyledLoad = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
`


export default TrainerPlans;
